import { queryClient } from '../lib/queryClient';

const DOCUMENT_DASHBOARD_KEYS = [
  'dashboard-diffused-count',
  'dashboard-opened-ratio',
  'dashboard-not-consulted-count',
  'dashboard-recent-documents',
  'dashboard-user-documents',
  'dashboard-diffused-documents',
  'dashboard-pending-documents',
  'dashboard-not-consulted-documents',
  'dashboard-validated-count',
  'dashboard-validated-documents',
];

const DOCUMENT_WORKFLOW_KEYS = [
  'document-nodes',
  'tasks',
  'validation-status',
  'diffusion-stats',
  'all-recipients',
  'pending-recipients',
  'folder-old-versions',
];

export const invalidateDocumentDashboards = (companyId: string) => {
  DOCUMENT_DASHBOARD_KEYS.forEach((key) =>
    queryClient.invalidateQueries({ queryKey: [key, companyId] }),
  );
};

export const invalidateDocumentWorkflow = (companyId: string) => {
  DOCUMENT_WORKFLOW_KEYS.forEach((key) =>
    queryClient.invalidateQueries({ queryKey: [key, companyId] }),
  );
  invalidateDocumentDashboards(companyId);
};
